var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_vm._v("正在加载中，如长时间出现此页面，请 "),_c('a',{on:{"click":function($event){return _vm.jump()}}},[_vm._v("点击刷新")]),_vm._v("。")])}
var staticRenderFns = []

export { render, staticRenderFns }